export default __webpack_public_path__ + "assets/tutorial-crouch.json";